var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-wrapper" },
    [
      _c("div", { staticClass: "__second-title" }, [
        _vm._v(_vm._s(_vm.$t("walletMintage.tokenList")))
      ]),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "mintage-table",
          attrs: {
            headList: [
              {
                class: "__ellipsis",
                text: "Token ID",
                cell: "tokenId"
              },
              {
                class: "__ellipsis",
                text: _vm.$t("walletMintage.tokenName"),
                cell: "tokenName"
              },
              {
                class: "__ellipsis",
                text: _vm.$t("walletMintage.tokenSymbol"),
                cell: "tokenSymbol"
              },
              {
                text: _vm.$t("walletMintage.totalSupply"),
                cell: "showTotalSupply"
              },
              {
                class: "__ellipsis",
                text: _vm.$t("walletMintage.decimals"),
                cell: "decimals"
              },
              {
                class: "__ellipsis",
                text: _vm.$t("walletMintage.isReIssuable"),
                cell: "isReIssuable"
              },
              {
                text: _vm.$t("walletMintage.maxSupply"),
                cell: "showMaxSupply"
              },
              {
                class: "__ellipsis",
                text: _vm.$t("walletMintage.isOwnerBurnOnly"),
                cell: "ownerBurnOnly"
              },
              {
                class: "__ellipsis",
                text: _vm.$t("tradeAssets.operate"),
                cell: "operate"
              }
            ],
            contentList: _vm.showTokenList
          }
        },
        [
          _vm._l(_vm.showTokenList, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                attrs: { slot: i + "showTotalSupplyAfter" },
                slot: i + "showTotalSupplyAfter"
              },
              [
                item.isTotalOver
                  ? _c(
                      "i",
                      { staticClass: "tipsicon __pointer" },
                      [
                        _c("tooltips", {
                          staticClass: "icon-tooltips",
                          attrs: { content: item.simpleTotalSupply }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.showTokenList, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                attrs: { slot: i + "showMaxSupplyAfter" },
                slot: i + "showMaxSupplyAfter"
              },
              [
                item.isMaxOver
                  ? _c(
                      "i",
                      { staticClass: "tipsicon __pointer" },
                      [
                        _c("tooltips", {
                          staticClass: "icon-tooltips",
                          attrs: { content: item.simpleMaxSupply }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.showTokenList, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                attrs: { slot: i + "operateBefore" },
                slot: i + "operateBefore"
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !item.isReIssuable,
                        expression: "!item.isReIssuable"
                      }
                    ]
                  },
                  [_vm._v("--")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.isReIssuable,
                        expression: "item.isReIssuable"
                      }
                    ],
                    staticClass: "btn __pointer",
                    on: {
                      click: function($event) {
                        return _vm.changeOwner(item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("walletMintage.changeOwnerConfirm.title"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.isReIssuable,
                        expression: "item.isReIssuable"
                      }
                    ],
                    staticClass: "btn __pointer",
                    on: {
                      click: function($event) {
                        return _vm.changeReIssuable(item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("walletMintage.reIssuableConfirm.title"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.isReIssuable,
                        expression: "item.isReIssuable"
                      }
                    ],
                    staticClass: "btn __pointer",
                    on: {
                      click: function($event) {
                        return _vm.issue(item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("walletMintage.issueConfirm.title"))
                    )
                  ]
                )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.changeOwnerToken
        ? _c(
            "show-confirm",
            {
              staticClass: "middle",
              attrs: {
                btnUnuse: !!(!_vm.address || !_vm.isValidAddress),
                title: _vm.$t("walletMintage.changeOwnerConfirm.title"),
                showMask: true,
                leftBtnTxt: _vm.$t("walletMintage.cancel"),
                leftBtnClick: _vm.cancelChangeOwner,
                rightBtnTxt: _vm.$t("walletMintage.submit"),
                rightBtnClick: _vm.toChangeOwner
              }
            },
            [
              _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("walletMintage.tokenName")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__input_row __unuse_input" }, [
                  _vm._v(_vm._s(_vm.changeOwnerToken.tokenName))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("walletMintage.tokenSymbol")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__input_row __unuse_input" }, [
                  _vm._v(_vm._s(_vm.changeOwnerToken.tokenSymbol))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("walletMintage.address")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__input_row __unuse_input" }, [
                  _vm._v(_vm._s(_vm.changeOwnerToken.owner))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "__row" },
                [
                  _c("div", { staticClass: "__row_t" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("walletMintage.changeOwnerConfirm.address")
                        ) +
                        "\n                "
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isValidAddress,
                            expression: "!isValidAddress"
                          }
                        ],
                        staticClass: "__err"
                      },
                      [_vm._v(_vm._s(_vm.$t("hint.addrFormat")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("vite-input", {
                    attrs: {
                      valid: _vm.validAddr,
                      placeholder: _vm.$t("wallet.placeholder.addr")
                    },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.issueToken
        ? _c(
            "show-confirm",
            {
              staticClass: "middle",
              attrs: {
                btnUnuse: !!(
                  !_vm.address ||
                  !_vm.isValidAddress ||
                  _vm.amountErr ||
                  !_vm.amount
                ),
                title: _vm.$t("walletMintage.issueConfirm.title"),
                showMask: true,
                leftBtnTxt: _vm.$t("walletMintage.cancel"),
                leftBtnClick: _vm.cancelIssue,
                rightBtnTxt: _vm.$t("walletMintage.submit"),
                rightBtnClick: _vm.toIssue
              }
            },
            [
              _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("walletMintage.tokenName")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__input_row __unuse_input" }, [
                  _vm._v(_vm._s(_vm.issueToken.tokenName))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("walletMintage.tokenSymbol")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__input_row __unuse_input" }, [
                  _vm._v(_vm._s(_vm.issueToken.tokenSymbol))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "__row" },
                [
                  _c("div", { staticClass: "__row_t" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("walletMintage.issueConfirm.amount")) +
                        "\n                "
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.amountErr,
                            expression: "amountErr"
                          }
                        ],
                        staticClass: "__err"
                      },
                      [_vm._v(_vm._s(_vm.amountErr))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("vite-input", {
                    attrs: { valid: _vm.validAmount },
                    model: {
                      value: _vm.amount,
                      callback: function($$v) {
                        _vm.amount = $$v
                      },
                      expression: "amount"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "__row" },
                [
                  _c("div", { staticClass: "__row_t" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("walletMintage.issueConfirm.address")) +
                        "\n                "
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isValidAddress,
                            expression: "!isValidAddress"
                          }
                        ],
                        staticClass: "__err"
                      },
                      [_vm._v(_vm._s(_vm.$t("hint.addrFormat")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("vite-input", {
                    attrs: {
                      valid: _vm.validAddr,
                      placeholder: _vm.$t("wallet.placeholder.addr")
                    },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }